module.exports = __webpack_public_path__ + "img/dingTalk_message_log.25b71183.jpg";